import { LoanApplication, LoanOption } from "@oneethos/shared"
import { useEffect, useState } from "react"
import { SubformProps } from "."
import { ProductSelection } from "../../components/product-selection"
import { useAppState } from "../../hooks"
import { LoanOptions } from "@oneethos/shared"

export const SelectLoanTerm = ({ formData, update, save }: Partial<SubformProps>) => {
  const { tenant } = useAppState()
  const [loanOptions, setLoanOptions] = useState<LoanOption[]>([])
  const [isLocked, setIsLocked] = useState(false)

  useEffect(() => {
    const options = LoanOptions.for(formData as LoanApplication, tenant.config.products)

    // TODO: this doesn't fully support cases where the proposal is created via API
    // but a product is not submitted on the proposal; it incorrectly shows the UI
    // as locked when it shouldn't be if the consumer navigates away from selection
    // and then back
    if (formData.productId && formData.source?.kind === 'api') {
      setLoanOptions(options.filter(p => p.product.id === formData.productId))
      setIsLocked(true)
    } else {
      setLoanOptions(options)
    }
  }, [])

  return <div>
    {isLocked ? <div className="alert alert-info">
      You have selected the following loan term. If this does not look accurate, please
      work with your installer to request a different loan term.
    </div> : <div className="text-start pb-3">
      Please select the loan term that best fits your needs.
      Monthly payments listed below are estimates and subject to change:
    </div>}

    <ProductSelection
      formData={formData}
      update={update}
      loanOptions={loanOptions}
    />

  </div>
}

export default SelectLoanTerm